'use client';

import Shape from "@/components/icons/Shape";
import FadeIn from "@/components/ui/FadeIn";
import Row from "@/components/ui/Row";
import type { ProductsCarouselItem } from "@/types/sections.model";
import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import ProductsCarousel from "./ProductsCarousel";

const ProductContent: React.FC<{item: ProductsCarouselItem}> = ({item}) => {

  const { contents } = item;

  return (
    <Box>
      {contents.map((content, idx) => {
        const isReverse = idx % 2 !== 0;

        return (
        <Box
          key={`Product-content-${content.title}-${idx}`}
          sx={{
            py: { xs: 32, lg: 48 },
            backgroundColor: isReverse ? 'secondary.main' : 'secondary.light',
          }}
        >
          <Container>
            <Row
              flexDirection={{
                xs: 'column',
                lg: isReverse ? 'row-reverse' : 'row'
              }}
              justifyContent={'space-between'}
              alignItems="center"
            >
              <Grid size={{xs: 12, lg: 6}}>
                <FadeIn>
                  <Image
                    src={content.image}
                    alt={content.title}
                    width={600}
                    height={600}
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: 24,
                      aspectRatio: '1 / 1',
                      objectFit: 'cover',
                    }}
                  />
                </FadeIn>
              </Grid>

              <Grid size={{xs: 12, lg: 5}} mt={{ xs: 24, lg: 0 }}>
                <Typography variant="headlineLGBold" component="h4" mb={{xs: 16, lg: 20}}>{content.title}</Typography>

                <Stack spacing={12}>
                  {content.highlights.map((highlight, hIdx) => (
                    <FadeIn key={hIdx} transition={{ delay: hIdx * 0.2 }}>
                      <Stack direction="row">
                        <Shape sx={{  fontSize: 60 }} color="primary" opacity={isReverse ? 0.1 : 0.25}/>
                        <Typography variant="bodyMDSemibold" component="div" sx={{ marginLeft: -20}}>{highlight}</Typography>
                      </Stack>
                    </FadeIn>
                  ))}
                </Stack>
              </Grid>

            </Row>

            {content.products && <ProductsCarousel content={content} items={content.products} />}
          </Container>
        </Box>
      )})}
    </Box> 
  );
}

export default ProductContent;